import FormHeader from "@/components/FormHeader";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { getListJalurJenis } from "@/services/getData";
import { JalurJenis } from "@/types";
import { ChevronRight } from "lucide-react";
import React, { useState } from "react";
import { LuListFilter } from "react-icons/lu";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function FormFilterPenerimaan({
  closeModal,
}: {
  closeModal: () => void;
}) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const idsUk = searchParams.get("ids_uk");
  const idsRefJalurJenis = searchParams.get("ids_ref_jalur_jenis") || "";

  const [selectedFilter, setSelectedFilter] = useState("JALUR");
  const [filter, setFilter] = useState<{
    program_studi: string[];
    jalur_jenis: string[];
  }>({
    program_studi: idsUk?.split("-") || [],
    jalur_jenis: idsRefJalurJenis?.split("-") || [],
  });
  // const [searchQueryProdi, setSearchQueryProdi] = useState("");

  // const { data: listUnitkerja, isPending: isPendingListUnitkerja } = useQuery({
  //   queryKey: ["listUnitkerja"],
  //   queryFn: getListUnitkerja,
  // });
  const { data: listJalurJenis, isPending: isPendingListJalurJenis } = useQuery(
    {
      queryKey: ["listJalurJenis"],
      queryFn: getListJalurJenis,
    },
  );

  const filteredListJalurJenis =
    listJalurJenis && listJalurJenis?.length > 0
      ? listJalurJenis?.filter((jalurJenis: JalurJenis) => {
          return (
            jalurJenis.jalur?.nama_jalur?.startsWith("Mandiri") &&
            (jalurJenis.nama_jalur_jenis_slug == "cbt" ||
              jalurJenis.nama_jalur_jenis_slug == "prestasi" ||
              jalurJenis.nama_jalur_jenis_slug == "talentscouting" ||
              jalurJenis.nama_jalur_jenis_slug == "skorutbk" ||
              jalurJenis.nama_jalur_jenis_slug == "kepemimpinan" ||
              jalurJenis.nama_jalur_jenis_slug == "sekolahlab")
          );
        })
      : [];

  // const listProdi = listUnitkerja?.filter((unitkerja: Unitkerja) => {
  //   return unitkerja.unitkerja_group_key == "5" && unitkerja.is_active;
  // });

  // const filteredListProdi = listProdi
  //   ? listProdi.filter((prodi: Unitkerja) => {
  //       return prodi?.nama
  //         ?.toLowerCase()
  //         .includes(searchQueryProdi.toLowerCase());
  //     })
  //   : [];

  const handleApplyFilter = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (filter.jalur_jenis.length > 0) {
      searchParams.set("ids_ref_jalur_jenis", filter.jalur_jenis.join("-"));
    } else {
      searchParams.delete("ids_ref_jalur_jenis");
    }

    if (filter.program_studi.length > 0) {
      searchParams.set("ids_uk", filter.program_studi.join("-"));
    } else {
      searchParams.delete("ids_uk");
    }

    navigate(`/admin/dashboard?${searchParams.toString()}`);
    closeModal();
  };

  return (
    <form
      onSubmit={handleApplyFilter}
      className="pb-20 relative flex flex-col gap-y-3"
    >
      <FormHeader title="Filter Data Rekap" icon={<LuListFilter />} />

      <section className="p-3 relative border rounded-xl">
        <div
          className="flex justify-between items-center"
          onClick={() =>
            setSelectedFilter((prev) => (prev === "JALUR" ? "" : "JALUR"))
          }
        >
          <span className="font-bold">Jalur</span>
          <Button type="button" size={"icon"} variant={"outline"}>
            <ChevronRight
              className={`${
                selectedFilter === "JALUR" ? "rotate-90" : ""
              } duration-300`}
            />
          </Button>
        </div>
        {selectedFilter === "JALUR" &&
          (isPendingListJalurJenis ? (
            "Loading..."
          ) : (
            <div className="mt-3 grid grid-cols-3 gap-5">
              {filteredListJalurJenis?.map((jalurJenis: JalurJenis) => {
                // const isChecked = filter.jalur_jenis.includes(
                //   String(jalurJenis.id_ref_jalur_jenis)
                // );

                return (
                  <div
                    key={jalurJenis.id_ref_jalur_jenis}
                    className="flex gap-3"
                  >
                    <Checkbox
                      checked={filter.jalur_jenis.includes(
                        String(jalurJenis.id_ref_jalur_jenis),
                      )}
                      onCheckedChange={(checked) => {
                        setFilter((prev) => {
                          const id = String(jalurJenis.id_ref_jalur_jenis);

                          return {
                            ...prev,
                            jalur_jenis: checked ? [id] : [],
                          };
                        });
                      }}
                    />
                    <Label>{jalurJenis.nama_jalur_jenis}</Label>
                  </div>
                );
              })}
            </div>
          ))}
      </section>

      {/* <section className="p-3 relative border rounded-xl max-h-[50vh] overflow-auto">
        <div
          className="flex justify-between items-center"
          onClick={() =>
            setSelectedFilter((prev) => (prev === "PRODI" ? "" : "PRODI"))
          }
        >
          <span className="font-bold">Program Studi</span>
          <Button type="button" size={"icon"} variant={"outline"}>
            <ChevronRight
              className={`${
                selectedFilter === "PRODI" ? "rotate-90" : ""
              } duration-300`}
            />
          </Button>
        </div>
        {selectedFilter === "PRODI" &&
          (isPendingListUnitkerja ? (
            "Loading..."
          ) : (
            <>
              <div className="py-3 sticky top-0">
                <Input
                  placeholder="Search..."
                  value={searchQueryProdi}
                  onChange={(event) => setSearchQueryProdi(event.target.value)}
                />
              </div>
              <div className="mt-3 grid grid-cols-2 gap-5">
                {filteredListProdi?.map((prodi: Unitkerja) => {
                  const isChecked = (filter.program_studi as string[]).includes(
                    String(prodi.uk_id)
                  );

                  return (
                    <div key={prodi.uk_id} className="flex gap-3">
                      <Checkbox
                        checked={isChecked}
                        onCheckedChange={(checked) => {
                          setFilter((prev) => {
                            const programStudi = [...prev.program_studi];

                            if (checked) {
                              if (!programStudi.includes(String(prodi.uk_id))) {
                                programStudi.push(String(prodi.uk_id));
                              }
                            } else {
                              const index = programStudi.indexOf(
                                String(prodi.uk_id)
                              );
                              if (index > -1) {
                                programStudi.splice(index, 1);
                              }
                            }

                            return {
                              ...prev,
                              program_studi: programStudi,
                            };
                          });
                        }}
                      />
                      <Label>{prodi.nama}</Label>
                    </div>
                  );
                })}
              </div>
            </>
          ))}
      </section> */}

      <div className="absolute bottom-3 left-3 right-3">
        <div className="flex justify-between">
          <div className="flex gap-3">
            <Button
              onClick={() => closeModal()}
              type="button"
              variant={"outline"}
            >
              Tutup
            </Button>
            <Button>Terapkan Filter</Button>
          </div>
          <Button
            type="button"
            variant={"outline"}
            onClick={() => {
              setFilter((prev) => ({
                ...prev,
                program_studi: [],
                gelombang: [],
                status_kelulusan: "",
                status_validasi: "",
              }));
              closeModal();
              navigate("/admin/dashboard?menu=DATA");
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    </form>
  );
}
